'use client';

import { ChevronDown } from '@/icons';

export const ClassRowCard = ({
  name,
  imageUrl,
  onClick,
}: {
  name: string;
  imageUrl?: string | null;
  onClick?: () => void;
}) => (
  <button
    type="button"
    aria-label={name}
    onClick={onClick}
    className="mb-focus-visible group relative flex w-full items-center overflow-hidden rounded-xl bg-white text-left shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] transition-all duration-200 hover:bg-gray-100 after:pointer-events-none after:absolute after:inset-0 after:rounded-xl after:ring-1 after:ring-inset after:ring-black/[0.12] after:shadow-[inset_0_-2px_0_0_rgba(24,29,39,0.06)]"
  >
    <div className="size-16 shrink-0 bg-gray-100">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt=""
          className="size-full object-cover"
        />
      ) : null}
    </div>
    <div className="flex min-w-0 flex-1 items-center gap-2 px-4 py-3">
      <span className="min-w-0 flex-1 truncate text-base font-semibold text-gray-900 transition-colors group-hover:text-red-400">
        {name}
      </span>
      <span className="inline-flex shrink-0 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
        <ChevronDown rotate={-90} className="h-5 w-5 text-red-400" />
      </span>
    </div>
  </button>
);
